module.exports = __webpack_public_path__ + "static/img/thai_qr_img_1.2f324b71.png";